module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_492019.26a5e948.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_492019.pdf
// module id = 888
// module chunks = 0